import { Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'

@Component({
	selector: 'app-form-error-message',
	standalone: true,
	imports: [TranslateModule],
	templateUrl: './form-error-message.component.html',
	styleUrl: './form-error-message.component.scss',
})
export class FormErrorMessageComponent {
	@Input({ required: true }) control!: FormControl
}
